import {Parser, string, boolean, record, field, array} from '@freckle/parser'

import {
  consoleFancyClient,
  extractData,
  type fancyOperations,
  type FancyOk
} from '@frontrow/console/src/open-api/clients'

export type ConsoleAgentT = {
  email: string
  verified: boolean
  groups: Array<string>
}

export const globalConsoleAgent: ConsoleAgentT = {
  email: 'unauthenticated',
  verified: false,
  groups: []
}

type ConsoleAgentResponseT = FancyOk<fancyOperations['getConsoleAgentR']>

export async function fetchConsoleAgent(): Promise<ConsoleAgentT> {
  const data: ConsoleAgentResponseT = extractData(await consoleFancyClient.GET('/2/console/agent'))

  const agent = Parser.run(
    data,
    record({
      email: string(),
      verified: field(boolean(), 'email_verified'),
      groups: array(string())
    })
  ) as ConsoleAgentT

  globalConsoleAgent.email = agent.email
  globalConsoleAgent.verified = agent.verified
  globalConsoleAgent.groups = agent.groups

  return agent
}

export function checkConnectionAjax(): Promise<boolean> {
  return fetchConsoleAgent()
    .then(() => true)
    .catch(e => {
      if (e.status === 403 || e.status === 404) return false
      else throw e
    })
}

export async function logoutConsoleAgent(): Promise<unknown> {
  const {data} = await consoleFancyClient.DELETE('/2/console/agent')
  return data
}
